import { get, post } from 'aws-amplify/api';

export class SBT {
    static async getTemplates(token, apiKey, isProd, clientId, clientSecret, groupId) {
        try {
            const templates = await post({
                apiName: 'cdyxoutreach',
                path: '/cci/sbt/templates',
                options: {
                    headers: {
                        'x-api-key': apiKey,
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: {
                        isProd,
                        clientId,
                        clientSecret,
                        groupId
                    }
                }
            }).response;

            return await templates.body.json();
        } catch (error) {
            console.error('Error getting SBT templates', error);
        }
    }
}